import { HttpClient } from '@angular/common/http';
import { KnowledgeBaseDetailInfo } from './knowledgebasedetailinfo';
import { Injectable } from '@angular/core';
import { CommonConstants } from '../../../../../common/constants/common-constants';
import { Observable } from 'rxjs';
import { KbaAttachment } from '../../model/kbaattachmentresponse';
import { RateInfoResponse } from '../../model/rateresponse';

@Injectable()

export class KnowledgeBaseDetailService {
    constructor(public http: HttpClient) {
    }

    public getKnowledgeBaseDetail(kbaId: number): Observable<KnowledgeBaseDetailInfo> {
        return this.http.get<KnowledgeBaseDetailInfo>(CommonConstants.SERVICE_VERSION_PATH_V1
            + '/customer/kbas/' + kbaId);
    }
    public getAttachmentDetails(kbaId: number) {
        return this.http.get<KbaAttachment>(CommonConstants.SERVICE_VERSION_PATH_V1
            + '/customer/kbas/' + kbaId + '/attachments');
    }

    public rateKba(kbaId: number, rating: number): Observable<RateInfoResponse> {
        return this.http.post<RateInfoResponse>(CommonConstants.SERVICE_VERSION_PATH_V1
            + '/customer/kbas/' + kbaId + '/rate?rating=' + rating, null);
    }

    public getSolutionDetailforRequests(requestNumber: number): Observable<KnowledgeBaseDetailInfo> {
        return this.http.get<KnowledgeBaseDetailInfo>(CommonConstants.SERVICE_VERSION_PATH_V1
            + '/customer/requests/' + requestNumber + '/solution');
    }

    public getSolutionAttachmentDetails(requestNumber: number) {
        return this.http.get<KbaAttachment>(CommonConstants.SERVICE_VERSION_PATH_V1
            + '/customer/requests/' + requestNumber + '/solution/attachments');
    }

    public solutionDetailrateKba(requestNumber: number, rating: number): Observable<RateInfoResponse> {
        return this.http.post<RateInfoResponse>(CommonConstants.SERVICE_VERSION_PATH_V1
            + '/customer/requests/' + requestNumber + '/solution/rate?rating=' + rating, null);
    }
}
